import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SkillService } from '../services/skill.service';

@Component({
  selector: 'app-filter-skill-detail',
  templateUrl: './filter-skill-detail.component.html',
  styleUrls: ['./filter-skill-detail.component.css']
})
export class FilterSkillDetailComponent implements OnInit {
  @Input() skillData: boolean;
  @Input() skillFilter;

  constructor(public skillService: SkillService, private route: Router) {
  }

  ngOnInit() {
  }

  onSelect(id, skill) {
    this.skillService.userDetail = skill;
    this.route.navigate(['/byUser', id]);
  }
  trackByFn(index) {
    return index;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/filter-skill-detail/filter-skill-detail.component.ts